import { determineShouldBeComplete } from '../helpers';
import StatusDetails from './StatusDetails';
import StatusDocuments from './StatusDocuments';
import { UIStatusGroup } from '../types';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { StatusPanelItems } from '..';
import { Dispatch, SetStateAction } from 'react';

interface GroupStatusStackProps {
  currentlyActiveStatusId: string;
  setDocumentViewerOpen: Dispatch<SetStateAction<boolean>>;
  orderItems?: StatusPanelItems[];
  uiStatusGroups: UIStatusGroup[];
  displayDocs?: boolean;
}

const GroupStatusStack = ({
  currentlyActiveStatusId,
  setDocumentViewerOpen,
  orderItems,
  uiStatusGroups,
  displayDocs = true
}: GroupStatusStackProps) => {
  const theme = useTheme();

  return (
    <>
      {uiStatusGroups.map((group, index) => (
        <Box
          key={`${group.id}-${group.date}`}
          sx={{
            padding: '10px',
            paddingLeft: '10px',
            borderRadius: '8px',
            ':nth-of-type(even)': { bgcolor: theme => (theme.palette.mode === 'light' ? '#F7F7F7' : '#333') }
          }}>
          {/* Status Date */}
          <Stack direction="row">
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: theme.palette.mode === 'light' ? '#2B2D42' : '#fff',
                  fontSize: '1rem',
                  fontWeight: 'bold'
                }}>
                {group.date}
              </Typography>
            </Box>
          </Stack>

          <Stack
            direction="column"
            gap="15px"
            sx={{
              width: '100%'
            }}>
            <Stack
              direction="row"
              sx={{
                width: '100%',
                p: 2,
                ':nth-of-type(even)': { bgcolor: '#F7F7F7' }
              }}>
              {/* Status Breakdown */}
              <Box sx={{ flex: 1 }}>
                <Stack direction="column" alignItems="flex-start" gap="10px" sx={{ height: '100%' }}>
                  <StatusDetails
                    {...{
                      status: group,
                      currentlyActiveStatusId,
                      orderItems,
                      overrideComplete: determineShouldBeComplete(uiStatusGroups, index, currentlyActiveStatusId)
                    }}
                  />
                </Stack>
              </Box>

              {/* Status Docs */}
              {displayDocs && <StatusDocuments {...{ status: group, setDocumentViewerOpen }} />}
            </Stack>
          </Stack>
        </Box>
      ))}
    </>
  );
};

export default GroupStatusStack;
